// extracted by mini-css-extract-plugin
export default {"icon":"DarkModeButton_icon__8VvF8"};